// extracted by mini-css-extract-plugin
export default {"container":"sidebarlink_container__vhwgl","activeLink":"sidebarlink_activeLink__DoRqs"};